(function ($) {
  $(document).on('click', ".toggle-modal", function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    // var that = $(this);
    // var attr = $(this).attr('data-modelevoiture');

    $('body').addClass('modal-open')
    $(target).addClass("open");

    // if (target.replace('#', '') == "rdv") {
    //   history.replaceState(null, null, window.location.origin + window.location.pathname + window.location.hash);
    // } else {
    //   var searchParams = new URLSearchParams(window.location.search);
    //   searchParams.set("m", target.replace('#', ''));
    //   if (typeof attr !== typeof undefined && attr !== false) {
    //     searchParams.set("c", that.attr("data-modelevoiture"));
    //   }
    //   history.replaceState(null, null, window.location.origin + window.location.pathname + "?" + searchParams + window.location.hash);
    // }
  });
  $(document).on('click', ".modal .close-modal", function () {
    close();
  });
  $(document).on('click', ".modal", function () {
    close();
  });
  $(document).on('click', ".modal .modal-inner", function (e) {
    e.stopPropagation();
  });
  $(document).on('keydown', function (e) {
    if (e.keyCode == 27) {
      close();
    }
  });

  function close() {
    $(".modal.open").removeClass("open");
    $('body').removeClass('modal-open');
    // history.replaceState(null, null, window.location.origin + window.location.pathname + window.location.hash);
  }

  // $(document).on('click', "[data-modelevoiture]", function (e) {
  //   var modelevoiture = $(this).attr("data-modelevoiture");

  //   if (modelevoiture.length && $("#voucher form #inscription_modelevoiture").length) {
  //     $("#voucher form #inscription_modelevoiture").val(modelevoiture.replace(/ /g, "+"));
  //   }
  // });

  // var urlParams = new URLSearchParams(window.location.search);
  // var modal = urlParams.get('m');
  // if (modal != "rdv") {
  //   if ($("#" + modal).length) {
  //     // var modelevoiture = $(".swiper-slide-active").attr("data-name");
  //     // if (modelevoiture.length && $("#voucher form #inscription_modelevoiture").length) {
  //     //   $("#voucher form #inscription_modelevoiture").val(modelevoiture);
  //     // }
  //     var modelevoiture = urlParams.get('c');
  //     if (modelevoiture !== null && $("#voucher form #inscription_modelevoiture").length) {
  //       $("#voucher form #inscription_modelevoiture").val(modelevoiture);
  //     }
  //     $('body').addClass('modal-open')
  //     $("#" + modal).addClass("open");
  //   }
  // }
})(jQuery);
